import React, { Component } from 'react';
import { Drawer, Table, Row, Button, Divider, Popconfirm, message } from 'antd';
import { RESTExecutor, withDomains } from '../../lib/domain';
import Title from 'antd/lib/typography/Title';
import ReportActionsAddEdit from './report_actions_addedit';
import { showErrorInNotification, formatMoney } from '../../lib/util';

const action_cols=({onEditPressed,onDeletePressed})=>[
    {
      title:"Action Name",
      dataIndex:'name',
      key:'name'
    },
    {
      title:"Plugin",
      dataIndex:'plugin_id',
      key:'plugin_id',
      // render:(reference)=>{
      //   let plugin=reference.plugin_id||{};
  
      //   return plugin.name
      // }
    },
    {
      title:"Action",
      key:'action',
      dataIndex:'id',
      render:(id,data)=><span>
        <Button type='link' onClick={()=>{
          typeof onEditPressed==='function'&&onEditPressed(data)
        }}>
          Edit
        </Button>
        <Divider type='vertical'/>
        <Popconfirm title="Are you sure you want to delete this item?" onConfirm={()=>{
          typeof onDeletePressed==='function'&&onDeletePressed(data)

        }}>
        <Button type='link' style={{color:'red'}}>
          Delete
        </Button>
        </Popconfirm>
      </span>
    }
  ]
class ReportActions extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            // supports 'add' or 'edit'
            drawer_type: null,
            selected_action: null,
            config_id: this.props.config_id
          }
          this.list_actions = RESTExecutor.list().config({
            label: 'report_actions',
          }).forId(this.props.config_id).connect(props.domains.reports);
      
          if (this.props.config_id) {
            this.list_actions.execute();
          }

          this.delete_action=RESTExecutor.delete().config({
              label:'report_actions_detail',
              params:{}
          }).callbacks((success)=>{
              message.success("Action Deleted");
              this.list_actions.execute()
          },(error)=>{
              showErrorInNotification(error)
          }).connect(props.domains.reports);

    }
    
  render() {
    let list_actions_resp = this.list_actions.response();
    let list_actions_data = list_actions_resp.result || {};
    let rowsData = list_actions_data.rows || [];
    let rowsMeta = list_actions_resp.meta || {};

    return (
      <div>
        <Table
        scroll={{x:true}}
          dataSource={rowsData}
      
          className='main-table'
          loading={list_actions_resp.fetching}
          title={() => <Row type='flex' justify='space-between' style={{
            alignItems: 'center'
          }}><div></div>
              <Button type='primary' onClick={()=>{
                this.setState({
                  drawer_type:'add',
                  selected_action:null
                })
              }}>Add New Action</Button>
          </Row>}
          columns={action_cols({
            onEditPressed:(data)=>{
              this.setState({
                drawer_type:'edit',
                selected_action:data
              })
            },
            onDeletePressed:(data)=>{
                this.delete_action.config({
                    params:{
                        config_id:this.props.config_id,
                        action_id:data.id
                    }
                }).execute()
            }
          })}
          size='small'
          rowKey={(record) => record.id}
          pagination={{
            simple: false,
                            position:'bottom',
            onChange: (current, size) => {
              this.list_actions.config({
                params: {
                  per_page: size,
                  page: current,
                }
              }).execute();
            },
            defaultCurrent: 1,
            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
            // defaultPageSize: 20,
            pageSize: (rowsMeta && rowsMeta.requested_count),

            total: (rowsMeta && rowsMeta.total_count),
            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
          }}
        />
        <Drawer 
        title={<Title level={3} style={{margin:0}}>Add Smart Action</Title>}
        placement="right"
        closable={false}
        width='50%'
        destroyOnClose
        onClose={() => {
            this.setState({
                drawer_type: null,
                selected_action:null
            });
            this.list_actions.execute()

        }}
        visible={this.state.drawer_type==='add'}
        >
          <ReportActionsAddEdit 
            config_id={this.state.config_id}
            onClose={() => {
              this.setState({
                  drawer_type: null,
                  selected_action:null
              });
              this.list_actions.execute()
          }}
          />
        </Drawer>

        <Drawer 
        title={<Title level={3} style={{margin:0}}>Edit Smart Action</Title>}
        placement="right"
        closable={false}
        width='50%'
        destroyOnClose
        onClose={() => {
            this.setState({
                drawer_type: null,
                selected_action:null
            });
            this.list_actions.execute()
        }}
        visible={this.state.drawer_type==='edit'}
        >
          <ReportActionsAddEdit 
          data={this.state.selected_action}
          config_id={this.state.config_id}
          action_id={this.state.selected_action&&this.state.selected_action.id}
          onClose={() => {
            this.setState({
                drawer_type: null,
                selected_action:null
            });
            this.list_actions.execute()
        }}
          />
        </Drawer>


      </div>
    );
  }
}

export default withDomains(ReportActions,"reports");
